import "core-js/modules/es6.array.find";
import "core-js/modules/web.dom.iterable";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "E:\\RiderProjects\\pdcweb\\node_modules\\@babel\\runtime-corejs2/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import { SortField, getElectricMotorChild } from "../../utils/helper";
import { quillEditor } from 'vue-quill-editor';
import { RefreshToken } from "../../api/Auth";
var that;
var roleArr = [];
export default {
  data: function data() {
    return {
      scaleRackArr: [],
      scalesArr: [],
      rackRollerTree: [],
      headTitle: '',
      viewVisible: false,
      isadd: false,
      scaleRackRollers: {},
      editVisible: false,
      scales: [],
      pageCount: 1,
      multipleSelection: [],
      loading: false,
      isResouceShow: 0,
      query: {
        Field1: '',
        Field2: '',
        Field3: '',
        PageIndex: 1,
        PageSize: 15
      },
      editorOption: {
        placeholder: '请输入内容！！！'
      },
      leftHeight: '',
      leftTreeHeight: '',
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      rules: {
        Name: [{
          required: true,
          message: '请输入震动传感器名称',
          trigger: 'blur'
        }],
        Code: [{
          required: true,
          message: '请输入震动传感器编码',
          trigger: 'blur'
        }],
        RollerID: [{
          required: true,
          message: '请选择所属托辊',
          trigger: 'blur'
        }]
      }
    };
  },
  components: {
    quillEditor: quillEditor
  },
  created: function created() {
    this.getRackRollerTree();
    this.getScaleRacks();
  },
  beforeCreate: function beforeCreate() {
    that = this;
  },
  mounted: function mounted() {
    this.setCJHeight();
  },
  methods: {
    getScaleRacks: function getScaleRacks() {
      var _this = this;

      this.$zybhttp.post('AIWeighing/GetScaleRackRollersList', this.query).then(function (res) {
        if (res.data.status == 0) {
          _this.scaleRackArr = res.data.data.list;
          console.log(_this.scaleRackArr);
        } else {
          _this.$notify.error(res.message);
        }
      }).catch(function (err) {
        return _this.$notify.error('网络异常！获取列表失败！');
      });
    },
    onEditorChange: function onEditorChange(_ref) {
      var html = _ref.html;
      this.content = html;
    },
    setCJHeight: function setCJHeight() {
      var _this2 = this;

      this.$nextTick(function () {
        // 页面渲染完成后的回调
        var headerHeight = document.getElementsByClassName('content')[0].offsetHeight;
        _this2.leftHeight = headerHeight * 0.93 + 'px';
        _this2.leftTreeHeight = headerHeight * 0.85 + 'px';
      });
    },
    handleNodeClick: function handleNodeClick(data) {
      var newdata = getElectricMotorChild(this.scalesArr, [data.electricMotorID], data.electricMotorID);
      this.query.Field3 = newdata.join(',');
      this.getData();
    },
    saveEdit: function saveEdit() {
      var _this3 = this;

      this.$refs['scaleRackRollers'].validate(function (valid) {
        if (valid) {
          _this3.isResouceShow = _this3.isResouceShow + 1; // this.scaleRackRollers.isDisplay = this.scaleRackRollers.isDisplay ? true : false;

          if (_this3.isadd) {
            _this3.$zybhttp.post('AIWeighing/ShockSensorAdd', _this3.scaleRackRollers).then(function (res) {
              if (res.data.status == 0) {
                _this3.$notify.success('添加成功');

                _this3.getRackRollerTree();

                _this3.editVisible = false;
                _this3.scaleRackRollers = {};
              } else {
                _this3.$notify.error(res.data.msg);
              }
            }).catch(function (err) {
              return _this3.$notify.error('网络异常！添加失败');
            });
          } else {
            _this3.$zybhttp.post('AIWeighing/ShockSensorUpdate', _this3.scaleRackRollers).then(function (res) {
              if (res.data.status == 0) {
                _this3.$notify.success('修改成功');

                _this3.getRackRollerTree();

                _this3.editVisible = false;
              } else {
                _this3.$notify.error(res.data.msg);
              }
            }).catch(function (err) {
              return _this3.$notify.error('网络异常！修改失败');
            });
          }
        } else {
          return false;
        }
      });
    },
    updateToken: function () {
      var _updateToken = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        var resRefresh;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return RefreshToken();

              case 2:
                resRefresh = _context.sent;

                if (resRefresh.status === 0) {
                  localStorage.setItem('token', resRefresh.msg);
                }

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function updateToken() {
        return _updateToken.apply(this, arguments);
      }

      return updateToken;
    }(),
    getData: function () {
      var _getData = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee2() {
        var _this4 = this;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.$zybhttp.post('AIWeighing/GetShockSensorList', this.query).then(function (res) {
                  if (res.data.status == 0) {
                    res = res.data;
                    var d = res.data.list;
                    _this4.scales = d;
                    _this4.pageCount = res.data.total || 0;
                  } else {
                    _this4.$notify.error(res.message);
                  }
                }).catch(function (err) {
                  return _this4.$notify.error('网络异常！获取列表失败！');
                });

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getData() {
        return _getData.apply(this, arguments);
      }

      return getData;
    }(),
    getRackRollerTree: function getRackRollerTree() {
      var _this5 = this;

      this.$zybhttp.get('AIWeighing/GetShockSensor', {}).then(function (res) {
        if (res.data.status == 0) {
          var d = res.data.data.list;
          _this5.scalesArr = d;
          _this5.scales = d;
          var transformedData = [];
          d.forEach(function (item) {
            var rackRoller = transformedData.find(function (b) {
              return b.electricMotorID === item.RollerID;
            });

            if (!rackRoller) {
              rackRoller = {
                label: item.RackRollerName,
                electricMotorID: item.RollerID,
                children: []
              };
              transformedData.push(rackRoller);
            }

            rackRoller.children.push({
              electricMotorID: item.ID,
              label: item.Name
            });
          });
          _this5.rackRollerTree = transformedData;
        } else {
          _this5.$notify.error(res.message);
        }
      }).catch(function (err) {
        return _this5.$notify.error('网络异常！获取列表失败！');
      });
    },
    changeUse: function changeUse(row) {
      var _this6 = this;

      this.$zybhttp.post('AIWeighing/ShockSensorUpdate', row).then(function (res) {
        if (res.data.status == 0) {
          _this6.$notify.success('修改成功');

          _this6.getData();
        } else {
          _this6.$notify.error('修改失败');
        }
      }).catch(function (err) {
        return _this6.$notify.error('网络异常！修改失败');
      });
    },
    handleEdit: function handleEdit(id, row) {
      this.scaleRackRollers = row;
      this.editVisible = true;
      this.isadd = false;
      this.headTitle = '修改震动传感器';
    },
    dbSelected: function dbSelected(row) {
      this.scaleRackRollers = row;
      this.editVisible = true;
      this.isadd = false;
      this.headTitle = '修改震动传感器';
    },
    handleShow: function handleShow(index, row) {
      this.scaleRackRollers = row;
      this.viewVisible = true;
    },
    handleAdd: function handleAdd() {
      this.scaleRackRollers = {};
      this.isadd = true;
      this.editVisible = true;
      this.headTitle = '新增震动传感器';
    },
    handlePageChange: function handlePageChange(val) {
      this.$set(this.query, 'PageIndex', val);
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    delAllSelection: function delAllSelection() {
      var _this7 = this;

      var length = this.multipleSelection.length;
      var str = '';
      var strValue = '';

      for (var i = 0; i < length; i++) {
        str += this.multipleSelection[i].Name + ' ';
        strValue += this.multipleSelection[i].ID + ',';
      }

      if (strValue.length == 0) {
        this.$notify.warning('请选择删除的行！');
        return;
      }

      this.$confirm('确定要删除吗？', '提示', {
        type: 'warning'
      }).then(function () {
        _this7.$zybhttp.get('AIWeighing/ShockSensorDel', {
          params: {
            loadCellsDelIDs: strValue
          }
        }).then(function (res) {
          if (res.data.status == 0) {
            _this7.getRackRollerTree();

            _this7.$notify.success("\u5220\u9664\u4E86".concat(str));
          } else {
            _this7.$notify.error(res.data.msg);
          }
        }).catch(function (err) {
          return _this7.$notify.error('网络异常！删除失败');
        });

        _this7.multipleSelection = [];
      }).catch(function () {});
    },
    indexMethod: function indexMethod(index) {
      return index + 1;
    }
  }
};